import React from 'react';
import styled from 'styled-components';
import { MattRow } from '../../containers/containers';
import { DataVariant, ListItemDataBlock, ListItemDataRow } from './types';

export const Container = styled(MattRow).attrs(() => ({}))<{
  decorationColor: string;
  decorationShadowColor: string;
  mobileHeight?: number;
}>`
  height: ${(props) => props.mobileHeight || 84}px;
  padding: 15px 20px;
  cursor: pointer;
  width: calc(100% - 8px);
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 0px;
    height: ${(props) => props.mobileHeight || 84}px;
    left: 0px;
    width: 2px;
    background: ${(props) => props.decorationColor};
    box-shadow: 0px 0px 10px ${(props) => props.decorationShadowColor};
    border-radius: 2px 0px 0px 2px;
  }
  @media (min-width: 768px) {
    padding: 0px 30px;
    height: 84px;
    &::after {
      height: 84px;
    }
  }
`;
export const StatusLabelContainer = styled.div`
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 20px;
  width: 90px;
  @media (min-width: 1280px) {
    width: 110px;
  }
`;

export const ClockIcon = styled.img`
  width: 10px;
  height: 10px;
  margin-right: 4px;
`;

export const DateContainer = styled.div`
  flex: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 80px;
  @media (min-width: 1280px) {
    width: 130px;
  }
`;

export const Icon = styled.img`
  width: 40px;
  height: 40px;
`;

const DefaultRow = ({ value, label }: { value: string; label: string }): JSX.Element => (
  <span className="text-12">
    {label}: <b>{value}</b>
  </span>
);

const HighlightedRow = ({ value, label }: { value: string; label: string }): JSX.Element => (
  <span className="text-12">
    {label}: <b className="text-blue">{value}</b>
  </span>
);

const GrayRow = ({ value, label }: { value: string; label: string }): JSX.Element => (
  <span className="text-10 text-lightgray">
    {value ? <b>{value} </b> : ''}
    {label}
  </span>
);

const DescriptiveHighlightedRow = ({
  value,
  label,
}: {
  value: string;
  label: string;
}): JSX.Element => (
  <span className="text-12">
    <b className="text-blue">{value}</b> {label}
  </span>
);

export const DataRow = ({ data }: { data: ListItemDataRow }): JSX.Element | null => {
  const { variant, value, label } = data;
  if (value === '') {
    return null;
  }

  switch (variant) {
    case DataVariant.highlighted:
      return <HighlightedRow value={value} label={label} />;
    case DataVariant.gray:
      return <GrayRow value={value} label={label} />;
    case DataVariant.descriptive_highlighted:
      return <DescriptiveHighlightedRow value={value} label={label} />;
    default:
      return <DefaultRow value={value} label={label} />;
  }
};

export const DataBlock = ({ data }: { data: ListItemDataBlock }): JSX.Element => (
  <div className="flex-1 flex flex-col justify-center md:px-1">
    {data.dataLines.map((lineData, index) => (
      <DataRow key={index} data={lineData} />
    ))}
  </div>
);
